import { LOCIZE_NS, MUTATION_KEYS, QUERY_KEYS } from '@avanta/shared/constants/common';
import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { type AxiosError, type AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { EmployeeService } from 'services/employees';
import { type CreateEmployeePayload, type Employee } from 'types/employees';

export const useCreateEmployee = (): UseMutationResult<
  AxiosResponse<Employee>,
  AxiosError,
  CreateEmployeePayload
> => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  return useMutation({
    mutationKey: [MUTATION_KEYS.CREATE_INSURED_PERSON],
    mutationFn: async body => EmployeeService.createEmployee(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_INSURED_USERS] });
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.FETCH_INSURED_USERS_COUNT] });
      toast.success(t('InsuredPersonsList.create.success'));
    },
    onError: () => {
      toast.error(t('InsuredPersonsList.create.error'));
    },
  });
};
